import React, { lazy, Suspense } from 'react';
import LoadingIndicator from '../../LoadingIndicator';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '../../utils/webpack/chunkRetry';
const LoadableRedux = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "tiercreator" */ '../redux/creator/ModuleLoadable')));
const LoadableTierPopup = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "tierpopup" */ './TierPopup')));
const LazyTierPopup = (props)=>/*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "LazyTierPopup"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(LoadingIndicator, {
            view: 'llama',
            withOverlay: true,
            usePortal: true
        })
    }, /*#__PURE__*/ React.createElement(LoadableRedux, null), /*#__PURE__*/ React.createElement(LoadableTierPopup, props)));
LazyTierPopup.displayName = 'LazyTierPopup';
export default LazyTierPopup;
